import {Component, inject, input} from "@angular/core";
import {Location} from "@angular/common";
import {Translations} from "@translations";
import {Router} from "@angular/router";
import {AutosaveConfig, AutosaveWidgetComponent} from "../../autosave-widget/autosave-widget.component";
import {ComponentLoadingContainerComponent} from "../../component-loading-container/component-loading-container.component";
import {MatDivider} from "@angular/material/divider";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIconButton} from "@angular/material/button";

export interface LoadingConfig {
	isLoading: boolean;
	hasError: boolean;
	errorMsgToken?: string;
	fontIcon?: string;
}

@Component({
	selector: "sim-basic-app-page-layout",
	templateUrl: "./basic-page-layout.component.html",
	styleUrls: ["./basic-page-layout.component.scss"],
	host: {
		"[class.dottedBackground]": "useDottedBackground()",
	},
	imports: [ComponentLoadingContainerComponent, MatDivider, TranslateModule, MatIcon, AutosaveWidgetComponent, MatTooltip, MatIconButton],
})
export class BasicPageLayoutComponent {
	// Inputs
	public headerLabel = input.required<keyof typeof Translations>();
	public isLoading = input.required<boolean>();
	public headerIcon = input<string | null>(null);
	public autosaveConfig = input<AutosaveConfig | null>(null);
	public hasError = input<boolean>(false);
	public backUrl = input<string | null>(null);
	public useDottedBackground = input<boolean>(false);

	// Readonly
	protected readonly T = Translations;

	// Injections
	private _location: Location = inject(Location);
	private _router: Router = inject(Router);

	protected historyBack(): void {
		if (this.backUrl()) {
			this._router.navigate([this.backUrl()]).then();
		} else {
			this._location.back();
		}
	}
}
